<div class="business-layout">
  <!-- Sidebar / Mobile Header -->
  <div class="menu-header">
    <left-menu
      [menuItems]="menuItems"
      [showPoints]="false"
      class="business-sidebar hidden md:flex"
    ></left-menu>

    <!-- Mobile Header -->
    <div class="business-mobile-header md:hidden">
      <img
        [src]="assetUrl + 'icons/gloget_logo-trans.png'"
        class="business-mobile-logo"
        alt="gloget logo"
      />

      <button
        type="button"
        (click)="openMenuDialog()"
        class="business-menu-button"
        aria-label="Open menu"
      >
        <img [src]="assetUrl + 'icons/menu.svg'" alt="" />
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <main class="business-main">
    <router-outlet></router-outlet>
  </main>
</div>
